import React, { FC, ReactNode } from 'react'

export const BuyerLeadsValuePropositionIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b3cfbb98507605cbd0d0b86c863ff75a_buyerLeads_avatar.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b3cfbb98507605cbd0d0b86c863ff75a_buyerLeads_avatar.png'
        }
        width={96}
        height={96}
        alt={''}
      />
    </div>
  )
}
